"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelContent = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledDiv = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  padding-bottom: 12px;
`;
const PanelContent = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    const classes = ['panel-content'];
    if (className)
        classes.push(className);
    return (react_1.default.createElement(StyledDiv, Object.assign({ className: classes.join(' ') }, props), children));
};
exports.PanelContent = PanelContent;
exports.default = exports.PanelContent;
//# sourceMappingURL=PanelContent.js.map